<template>
  <div class="file_wrap">
    <div class="file_nav">
      <div
        v-for="(item, i) in fileTypeData"
        :key="i"
        :class="curIdx == i ? 'active' : ''"
        @click="navChange(i)"
      >
        <img :src="curIdx == i ? item.activeImg : item.defaultImg" alt="" />
        <span>{{ item.type }}</span>
      </div>
    </div>
    <!-- 495 -->
    <el-table
      class="file_table"
      empty-text="暂无数据"
      :header-cell-style="{ background: '#F4F6FA', color: '#9EABBE' }"
      :row-style="{ height: '72px' }"
      :cell-style="firstColumnStyle"
      height="400"
      :data="tableData"
      :border="false"
      style="width: 100%"
    >
      <el-table-column label="文件名">
        <template slot-scope="scope">
          <div class="first-column">
            <div v-for="(item, index) in fileTypeImgData" :key="index">
              <img
                v-show="scope.row.fileType == item.id"
                :src="item.fileImg"
                alt=""
              />
              <p
                style="margin-left: 10px"
                v-show="scope.row.fileType == item.id"
              >
                {{ scope.row.fileName }}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上传时间" width="200">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.uploadTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          {{ scope.row.fileStatus }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "table-template",
  props: {
    tableData: {
      type: Array,
      default: [
        {
          fileId: "1123",
          fileName: "123123",
          fileStatus: "完成",
          fileType: "3",
          uploadTime: "ewqe",
          videoType: "1",
        },
      ],
    },
  },
  data() {
    return {
      fileTypeData: [
        // {
        //   defaultImg: require("../assets/images/guanw_btn_yinp@2x.png"),
        //   activeImg: require("../assets/images/guanw_btn_yinp_djyh@2x.png"),
        //   type: "音频",
        //   id: 1,
        // },
        {
          defaultImg: require("../assets/images/guanw_btn_ship@2x.png"),
          activeImg: require("../assets/images/guanw_btn_ship_djyh@2x.png"),
          type: "视频",
          id: 2,
        },

        {
          defaultImg: require("../assets/images/guanw_btn_ppt@2x.png"),
          activeImg: require("../assets/images/guanw_btn_ppt_djyh@2x.png"),
          type: "PPT",
          id: 3,
        },
        {
          defaultImg: require("../assets/images/guanw_btn_word@2x.png"),
          activeImg: require("../assets/images/guanw_btn_word_djyh@2x.png"),
          type: "Word",
          id: 4,
        },
        {
          defaultImg: require("../assets/images/guanw_btn_pdf@2x.png"),
          activeImg: require("../assets/images/guanw_btn_pdf_djyh@2x.png"),
          type: "PDF",
          id: 5,
        },
      ],
      fileTypeImgData: [
        {
          fileImg: require("../assets/images/zb_wj_mp3@2x.png"),
          type: "音频",
          id: 1,
        },
        {
          fileImg: require("../assets/images/zb_wj_mp4@2x.png"),
          type: "视频",
          id: 2,
        },
        {
          fileImg: require("../assets/images/zb_wj_ppt@2x.png"),
          type: "PPT",
          id: 3,
        },
        {
          fileImg: require("../assets/images/zb_wj_wenda@2x.png"),
          type: "Word",
          id: 4,
        },
        {
          fileImg: require("../assets/images/zb_wj_pdf@2x.png"),
          type: "PDF",
          id: 5,
        },
      ],
      curIdx: 0,
      fileType: 2, //文件类型 默认1
    };
  },
  methods: {
    handleEdit(index, row) {
      console.log(index, row);
      this.$emit("delCurRow", index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    firstColumnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        //第三第四列的背景色就改变了2和3都是列数的下标
        return "color:#595F66;";
      }
    },
    navChange(idx) {
      let _this = this;
      _this.curIdx = idx;
      _this.fileType = _this.fileTypeData[idx].id;
      _this.$emit("fileTypeEvent", _this.fileTypeData[idx].id);
    },
    // 判断文件类型
    matchType(suffixVal) {
      // 返回结果
      let result_1 = ""; //视频
      let result_2 = ""; //音频
      let result_3 = ""; //PPT
      let result_4 = ""; //Word
      let result_5 = ""; //PDF

      // 类型格式数组
      let videolist = [
        "3gp",
        "asf",
        "avi",
        "dat",
        "dv",
        "flv",
        "f4v",
        "m2t",
        "m3u8",
        "m4v",
        "mj2",
        "mjpeg",
        "mkv",
        "mov",
        "mp4",
        "mpe",
        "mpg",
        "mpeg",
        "mts",
        "ogg",
        "qt",
        "rm",
        "rmvb",
        "swf",
        "ts",
        "vob",
        "wmv",
        "webm",
      ]; //视频类型格式数组
      let audiolist = [
        "aac",
        "ac3",
        "acm",
        "amr",
        "ape",
        "caf",
        "flac",
        "m4a",
        "mp3",
        "ra",
        "wav",
        "wma",
      ]; //音频类型格式数组
      let pptlist = ["ppt", "pptx"]; //PPT类型格式数组
      let wordlist = ["doc", "docx"]; //Word类型格式数组
      let pdflist = ["pdf"]; //PDF类型格式数组

      // 进行视频匹配
      result_1 = videolist.some(function (item) {
        return (item = suffixVal);
      });
      if (result_1 != "") {
        return "视频";
      }

      // 进行音频匹配
      result_2 = audiolist.some(function (item) {
        return (item = suffixVal);
      });
      if (result_2 != "") {
        return "音频";
      }

      // 进行PPT匹配
      result_3 = pptlist.some(function (item) {
        return (item = suffixVal);
      });
      if (result_3 != "") {
        return "PPT";
      }

      // 进行Word匹配
      result_4 = wordlist.some(function (item) {
        return (item = suffixVal);
      });
      if (result_4 != "") {
        return "Word";
      }

      // 进行PDF匹配
      result_5 = pdflist.some(function (item) {
        return (item = suffixVal);
      });
      if (result_5 != "") {
        return "PDF";
      }
      return "未知类型";
    },
  },
};
</script>
<style lang="less">
.file_wrap {
  background: #fff;
  padding: 16px 30px 122px;
  .file_nav {
    height: 72px;
    display: flex;
    flex-direction: row;
    align-items: center;

    div {
      font-size: 16px;
      color: #9eabbe;
      width: 100px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #9eabbe;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 20px;
      img {
        width: 24px;
        height: 24px;
      }
    }

    .active {
      color: #fff;
      background: #41a1ff;
      border-color: #41a1ff;
    }
  }
  .file_table {
    font-size: 16px;
    color: #9eabbe;
    .first-column div {
      display: flex;
      align-items: center;
      img {
        width: 56px;
        height: 56px;
      }
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }
    .el-button {
      text-align: left;
      font-size: 16px;
      color: #fe6c6d;
      width: 100%;
      height: 100%;
    }
    // **增加样式级别就行啦**
    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #212e3e !important;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      width: 6px; // 横向滚动条
      height: 6px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
  }
}
</style>